import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { login } from "../../../../state/actions";

const Login = ({ PresentationComponent, ...rest }) => {
  const dispatch = useDispatch();

  return <PresentationComponent login={() => dispatch(login())} {...rest} />;
};

Login.propTypes = {
  PresentationComponent: PropTypes.elementType.isRequired
};

export default Login;
